import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as dashboardService from "../services/dashboard.services";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const [showDashboardCount, setShowDashboardCount] = useState({});

  const { t } = useTranslation();

  useEffect(() => {
    dashboardService
      .Counts()
      .then((response) => {
        setShowDashboardCount(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);
  return (
    <>
      <div className="row row-sm animation_fade">
        <div className="col-sm-12 col-lg-12 col-xl-12">
          <div className="row row-sm">
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/cafe-management/cafe/list/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                     
                        <i className="fa fa-coffee" style={{fontSize:"20px"}}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                         { t("admin.dashboard.dashboard_link_cafes")}
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.users
                              ? showDashboardCount.users
                              : "0"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
